export function createBaseQuery(width?: string, height?: string, inch?: string) {
    if (width && inch) {
        return `${width + (height ? "/" : "") + (height || "")}R${inch} `
    }
}
